import { countryOptions } from '@/components/Forms/utils/countryOptions';

export const createFullAddressString = (
    address1: string,
    city: string,
    stateCode: string,
    postalCode: string,
    country: string,
    address2?: string
): string => {
    const location = [address1];
    if (address2) {
        location.push(address2);
    }
    location.push(city, stateCode, postalCode, country);
    return location.join(' ').replace(/\s+/g, ' ').trim();
};

/**
 * @param city
 * @param state - If state code is used, it will be capitalized
 * @param country - Country code or full country name are acceptable
 * @param useFullCountryName - If true and a country code is passed in, it will be returned as the full country name
 * @returns - Address string based on city, state, and country
 */
export const createShortAddressString = (
    city: string,
    state: string,
    country: string,
    useFullCountryName = true
): string => {
    const location: string[] = [];
    if (city) {
        location.push(city);
    }
    if (state) {
        let stateToUse = state.length === 2 ? state.toUpperCase() : state;
        location.push(stateToUse);
    }
    if (country) {
        let countryToUse = country;
        const isCountryCode = country.length === 2;
        if (isCountryCode && useFullCountryName) {
            const foundCountry = countryOptions.find(({ value }) => value.toLowerCase() === country.toLowerCase());
            countryToUse = foundCountry?.label ?? country.toUpperCase();
        }
        location.push(countryToUse);
    }
    return location.join(', ').replace(/\s+/g, ' ').trim();
};
